import { getId } from '@common/utils/brandDiffsUtils';
import StoreLocator from '@components/storelocator/StoreLocator';
import GoogleMapScript from '@utils/GoogleMapScript';
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
const StorePageMoncler = React.lazy(() => import('@components/storelocator/StorePage'));
const StorePageStone = React.lazy(() => import('@stone/components/storelocator/StorePage'));
const StoreLocatorContainer = (props) => {
    return (React.createElement(GoogleMapScript, null,
        React.createElement(Router, { basename: window.basePath },
            React.createElement(Switch, null,
                React.createElement(Route, { path: "/:lang/storelocator/:country/:city/:store" }, getId() == 'MO' ? React.createElement(StorePageMoncler, Object.assign({}, props)) : React.createElement(StorePageStone, Object.assign({}, props))),
                React.createElement(Route, { path: "/:lang/storelocator/:country/:city" },
                    React.createElement(StoreLocator, Object.assign({}, props))),
                React.createElement(Route, { path: "/:lang/storelocator/:country" },
                    React.createElement(StoreLocator, Object.assign({}, props))),
                React.createElement(Route, { path: "/:lang/storelocator" },
                    React.createElement(StoreLocator, Object.assign({}, props)))))));
};
export default StoreLocatorContainer;
